import { Component, OnDestroy } from '@angular/core';
import { BaseComponent } from '@shared/components/base.component';
import { IDataRefreshRequestParams } from '@shared/components/datatable/datatable.interface';
import { BehaviorSubject, Subscription } from 'rxjs';

@Component({ template: '' })
export abstract class DatatableBaseComponent extends BaseComponent implements OnDestroy {
  public readonly datatableParams$ = new BehaviorSubject<IDataRefreshRequestParams | null>(null);

  protected readonly subscriptions: Subscription[] = [];

  public ngOnDestroy(): void {
    this.subscriptions?.forEach((subscription) => subscription?.unsubscribe());
  }
}
